import { DomElementAlignment, DomTargetPosition } from '../enums';
import Tooltip from '../tooltip-component/tooltip.component';
import DOMPurify from 'dompurify';
import clsx from 'clsx';
import { useScreenSize } from '../common-hooks';

const createMarkup = (value: string) => {
  return { __html: DOMPurify.sanitize(value, { USE_PROFILES: { html: true } }) };
};

interface HelpDescriptionProps {
  description: string;
}

const HelpDescription = ({ description }: HelpDescriptionProps) => {
  return <div dangerouslySetInnerHTML={createMarkup(description)}></div>;
};

export interface HelpComponentProps {
  description: string;
  className?: string;
  tooltipZIndexCheck?: boolean;
  tooltipAlignment?: DomElementAlignment;
  tooltipTargetPosition?: DomTargetPosition;
}

export default function HelpComponent({
  description,
  tooltipZIndexCheck = false,
  tooltipAlignment = DomElementAlignment.TopRight,
  tooltipTargetPosition = DomTargetPosition.Left,
  className,
}: HelpComponentProps) {
  const { isMobile } = useScreenSize();
  const _wrapperClassName = clsx('odin-cursor-default', className);

  return (
    <Tooltip
      tooltipAlignment={tooltipAlignment}
      tooltipTargetPosition={tooltipTargetPosition}
      description={<HelpDescription description={description} />}
      wrapperClassName={_wrapperClassName}
      tooltipClassName="-odin-mt-1 odin-bg-mono-1 odin-max-w-sm odin help-links"
      dependOnChildren={true}
      exitDebounceTime={150}
      tooltipZIndexCheck={tooltipZIndexCheck}
      shouldUseCreatePortal={isMobile}
      enableMobileTouch={true}
    >
      <div className="odin-h-4 odin-w-4 odin-rounded-full odin-bg-info odin-text-center odin-text-xs odin-font-bold odin-text-mono-1">
        ?
      </div>
    </Tooltip>
  );
}
